import $ from 'jquery';
import isViewport from '../../scripts/util/window/isViewport';
import {phone} from '../../scripts/util/window/isViewport';
import Map from '../map/map';

export default class Landing {
	constructor(options) {
		const defaults = {
			el: '.js-landing'
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		return this;
	}

	initTabs() {
		this.$links = this.$el.find('.landing__buttons-block a');

		this.$links.on('click', this.toggleTab);
	}

	destroyTabs() {
		this.$links.off('click');
	}

	toggleTab(e) {
		e.preventDefault();

		const $target = $(e.currentTarget);
		const id = $target.attr('href');
		const self = this;
		let $content;

		if ($target.hasClass('_active')) {
			$content = $target
				.removeClass('_active')
				.next()
				.addClass('hidden-phone');

			$('.__' + id.replace('#', '')).replaceWith($content);
		} else {
			$content = $(id)
				.removeClass('hidden-phone');

			$content
				.before(`<div class="__${id.replace('#', '')}"><div/>`);

			$target
				.addClass('_active')
				.after($content);
		}

		if (!self.mapInited) {
			setTimeout(function () {
				new Map().render();
				self.mapInited = true;
			});
		}
	}

	checkViewport() {
		if (this.$el.length && isViewport(phone)) {
			this.initTabs();
			this.inited = true;
		} else if (this.inited) {
			this.destroyTabs();
		}
	}

	render() {
		$(window).on('resize', $.proxy(this.checkViewport, this));

		this.checkViewport();

		return this;
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/langing/index.js
 **/